import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "msg-reply" }
const _hoisted_2 = { class: "reply-body" }
const _hoisted_3 = { class: "reply-msg" }
const _hoisted_4 = { class: "reply-msg" }

import MsgReplyMenu from "@/views/ChatMessage/MsgReplyMenu.vue";
import MsgSeekPart from "@/views/ChatMessage/MsgSeekPart.vue";
import { isCompactMode } from "@/data/pubilc";
import UaMarkdown from "@/components/ua2-markdown/ua-markdown.vue";
import CsdVditor from "@/components/vditor/csd-vditor.vue";
import { toRefs, computed } from "vue";
import {
  chatList,
  chatStatus,
  deleteChatObj,
  sendMsg,
} from "@/views/Home/useData/module/chat";
import { v3 } from "uuid";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import { storeToRefs } from "pinia";
import publicStore from "@/store/publicStore";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { showVIPDialogue } from "@/components/Dialogues/useData/useDialogues";


export default /*@__PURE__*/_defineComponent({
  __name: 'MsgReply',
  props: {
  msgObj: {
    type: Object,
    required: true,
  },
  msgIndex: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const { isLogin, isVip } = storeToRefs(publicStore());

const props = __props;

const { msgObj, msgIndex } = toRefs(props);

const showCotent = computed(() => {
  if (chatList.length === 0) {
    return "";
  }
  const msgItem = chatList[chatList.length - 1] as any;
  const replying =
    msgItem.id === msgObj.value.id &&
    chatStatus.isReplying &&
    !msgObj.value.content;
  return replying ? "正在回复..." : msgObj.value.content;
});

const isReplying = computed(() => {
  if (chatList.length === 0) {
    return false;
  }
  return (
    chatList[chatList.length - 1].id === msgObj.value.id &&
    chatStatus.isReplying
  );
});

const isLastOne = computed(() => {
  return msgIndex.value === chatList.length - 1;
});

const isSpecialist = computed(() => {
  return false;
  // return ["Specialist"].includes((this.sessionId || "").split(".")[0]);
});

const menuAction = (index: number) => {
  //0 copy 1 resend
  if (index === 0) {
    ElMessage.success("已复制");
    Clipboard.copy(msgObj.value.content);
  } else {
    //删除原来的，重新发送
    if (!isLogin.value) {
      openLoginDialog();
      return;
    }

    if (isReplying.value) {
      return;
    }

    if (!isVip.value) {
      showVIPDialogue.value = true;
      return;
    }

    const chat = msgObj.value as any;
    const chatUser = chatList.find((i) => i.id == chat.id && i.role == "user");
    if (!chatUser) return;
    deleteChatObj(chat.id);
    sendMsg(chatUser.content);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["body", { 'body-compact': _unref(isCompactMode), 'bottom-space': isLastOne.value }])
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "icon"
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (isReplying.value)
            ? (_openBlock(), _createBlock(UaMarkdown, {
                key: 0,
                source: showCotent.value,
                showLine: false
              }, null, 8, ["source"]))
            : (isSpecialist.value)
              ? (_openBlock(), _createBlock(CsdVditor, {
                  key: 1,
                  point: _ctx.item.key,
                  content: showCotent.value,
                  vditorShowInAi: _ctx.vditorShowInAiStatus,
                  "onUpdate:vditorShowInAi": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vditorShowInAiStatus) = $event))
                }, null, 8, ["point", "content", "vditorShowInAi"]))
              : (_openBlock(), _createBlock(UaMarkdown, {
                  key: 2,
                  source: showCotent.value,
                  showLine: false
                }, null, 8, ["source"]))
        ]),
        (!isReplying.value)
          ? (_openBlock(), _createBlock(MsgReplyMenu, {
              key: 0,
              onMenuAction: menuAction
            }))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 1,
              placement: "bottom-start",
              width: 80,
              trigger: "hover",
              "show-arrow": false,
              "popper-class": "my-popper"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (isReplying.value)
                    ? (_openBlock(), _createBlock(UaMarkdown, {
                        key: 0,
                        source: showCotent.value,
                        showLine: false
                      }, null, 8, ["source"]))
                    : (isSpecialist.value)
                      ? (_openBlock(), _createBlock(CsdVditor, {
                          key: 1,
                          point: _ctx.item.key,
                          content: showCotent.value,
                          vditorShowInAi: _ctx.vditorShowInAiStatus,
                          "onUpdate:vditorShowInAi": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vditorShowInAiStatus) = $event))
                        }, null, 8, ["point", "content", "vditorShowInAi"]))
                      : (_openBlock(), _createBlock(UaMarkdown, {
                          key: 2,
                          source: showCotent.value,
                          showLine: false
                        }, null, 8, ["source"]))
                ])
              ]),
              default: _withCtx(() => [
                (!isReplying.value)
                  ? (_openBlock(), _createBlock(MsgReplyMenu, {
                      key: 0,
                      onMenuAction: menuAction
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})